const { typePolicies } = require('@shared-ui/apollo-type-policies');

module.exports = {
  ...typePolicies
};
